import { Button, Dropdown, Space } from "antd";
import {
  DownOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";

import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import ProficiencySetter from "../../util/ProficiencySetter";
import ClassTypeSetter from "../../util/ClassTypeSetter";
import GenderSetter from "../../util/GenderSetter";
import MaritalStatusSetter from "../../util/MaritalStatusSetter";
import MajorSetter from "../../util/MajorSetter";
import DesiredPlanSetter from "../../util/DesiredPlanSetter";
import IntroducedBySetter from "../../util/IntroducedBySetter";
import dayjs from "dayjs";
function htmlToPlainText(htmlString) {
  return htmlString.replace(/<[^>]*>/g, "");
}

function set_right_to_left(wb) {
  if (!wb.Workbook) wb.Workbook = {};
  if (!wb.Workbook.Views) wb.Workbook.Views = [];
  if (!wb.Workbook.Views[0]) wb.Workbook.Views[0] = {};
  wb.Workbook.Views[0].RTL = true;
}
function replaceBlockLevelElementsWithNewline(htmlContent) {
  // List of block-level elements
  const blockLevelElements = [
    "div",
    "p",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "ul",
    "ol",
    "li",
    "table",
    "tr",
    "td",
    "th",
    "blockquote",
    "pre",
    "address",
    "article",
    "aside",
    "canvas",
    "dd",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "header",
    "hr",
    "main",
    "nav",
    "noscript",
    "output",
    "section",
    "video",
  ];

  // Create a regex pattern to match block-level elements
  const blockLevelPattern = new RegExp(
    `</?(${blockLevelElements.join("|")})[^>]*>`,
    "gi"
  );

  // Replace block-level elements with newline
  let text = htmlContent.replace(blockLevelPattern, "\n");

  // Replace &nbsp; with a space
  text = text.replace(/&nbsp;/g, " ");

  return text;
}
const FormExportDropdown = ({
  name,
  data,
  mapper,
  disabled,
  className,
  tableId,
  LevelSetter
}) => {

  if (!data || (data && typeof data !== "object")) {
    return;
  }
  const nowDate = dayjs(new Date(), { jalali: true });
  const fileName = `${name} - ${nowDate.get("day")}/${nowDate.get(
    "month"
  )}/${nowDate.get("year")}`;
  const tableRows = [
    // [name, "نام فایل"]
  ];
 
  for (let key in data) {
    let rowData;
    const mappedKey = mapper[key];
    let value = data[key];
    if (mappedKey) {
      if (typeof value === "string") {
        value = replaceBlockLevelElementsWithNewline(value).replace(
          /&nbsp;/g,
          " "
        );
      }
      if (key === "deadline") {
        let jalaliDate = new Date().toLocaleDateString("fa-IR-u-nu-latn", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
        rowData = [jalaliDate, mappedKey];
      }
      else if (key === "personalities") {
        rowData = [value.join(" - "), mappedKey];
      } else if (key === "level") {
        rowData = [value ? LevelSetter(value) : "", mappedKey];
      } else if (key === "proficiency") {
        rowData = [value ? ProficiencySetter(value) : "", mappedKey];
      } else if (key === "class_type") {
        rowData = [value ? ClassTypeSetter(value) : "", mappedKey];
      } else if (key === "gender") {
        rowData = [value ? GenderSetter(value) : "", mappedKey];
      } else if (key === "marital_status") {
        rowData = [value ? MaritalStatusSetter(value) : "", mappedKey];
      } else if (key === "education_stage") {
        rowData = [value ? MajorSetter(value) : "", mappedKey];
      } else if (key === "desired_plan") {
        rowData = [value ? DesiredPlanSetter(value) : "", mappedKey];
      } else if (key === "introduced_by") {
        rowData = [value ? IntroducedBySetter(value) : "", mappedKey];
      } else {
        rowData = [
          value ? htmlToPlainText(`${value}`).replace(":", "") : "",
          mappedKey,
        ];
      }

      tableRows.push(rowData);
    }
  }
  const dataSource = tableRows.map((value) => {
    return {
      "نام ستون": value[1],
      مقدار: value[0],
    };
  });

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(dataSource, {
      header: ["نام ستون", "مقدار"],
    });
    const workbook = XLSX.utils.book_new();
    set_right_to_left(workbook);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, fileName + ".xlsx");
  };
  const handlePrint = () => {
    var doc = new jsPDF("l", "mm", [297, 210]);
    doc.setLanguage("fa-IR");
    doc.viewerPreferences({ Direction: "R2L" }, true);
    autoTable(doc, {
      body: tableRows,
      styles: {
        font: "IRANSansWeb",
        halign: "right",
        minCellWidth: 48,
        cellPadding: 4,
        valign: "middle",
        overflow: "linebreak",
      },
    });

    const input = document.getElementById(tableId);
    if (input && tableId) {
      console.log(input);
      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        doc.addPage();
        const imgProps = doc.getImageProperties(imgData);
        const pdfWidth = doc.internal.pageSize.getWidth() - 64;
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        doc.addImage(imgData, "PNG", 32, 32, pdfWidth, pdfHeight);
        doc.save(fileName + ".pdf");
      });
    } else {
      doc.save(fileName + ".pdf");
    }
  };

  const items = [
    {
      label: (
        <Space
          align="center"
          onClick={() => {
            exportToExcel();
          }}
        >
          <FileExcelOutlined /> اکسل (Excel){" "}
        </Space>
      ),
      key: "0",
    },
    {
      label: (
        <Space onClick={handlePrint} align="center">
          <FilePdfOutlined /> پی دی اف (PDF)
        </Space>
      ),
      key: "1",
    },
  ];
  return (
    <Dropdown
      disabled={disabled}
      menu={{
        items,
      }}
      trigger={["click"]}
      className={className}
    >
      <Button>
        <Space>
          <DownOutlined />
          خروجی
        </Space>
      </Button>
    </Dropdown>
  );
};
export default FormExportDropdown;
